import React, { useEffect } from 'react';
import HeroSection from '@/components/HeroSection';
import ProfessionTicker from '@/components/ProfessionTicker';
import Features from '@/components/Features';
import TargetAudience from '@/components/TargetAudience';
import ClientAppSection from '@/components/ClientAppSection';
import PracticeShiftSection from '@/components/PracticeShiftSection';
import PricingSection from '@/components/PricingSection';
import FaqSection from '@/components/FaqSection';
import BlogInsightsSection from '@/components/BlogInsightsSection';
import AboutUsSection from '@/components/AboutUsSection';
import MissionSection from '@/components/MissionSection';
import WhyWeExistSection from '@/components/WhyWeExistSection';
import CallToAction from './CallToAction';
import { recordLandingOperationalLocationVisit } from '@/lib/landingOperations';

const LandingPageContent: React.FC = () => {
  useEffect(() => {
    recordLandingOperationalLocationVisit();
  }, []);

  return (
    <main className="flex-grow">
      <HeroSection />
      <ProfessionTicker />
      <section id="about-us" className="scroll-mt-24">
        <AboutUsSection />
        <MissionSection />
      </section>
      <Features />
      <TargetAudience />
      <ClientAppSection />
      <PracticeShiftSection />
      <WhyWeExistSection />
      <PricingSection />
      <BlogInsightsSection />
      <FaqSection />
      <CallToAction />
    </main>
  );
};

export default LandingPageContent;
